<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7">
                        <div class="font-weight-bold body-1">
                            Editar Orden de trabajo
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="7">
                        <v-form ref="form" @submit.prevent="save">
                            <item-form ref="SaleOrderForm" :values="form" @save="save" :serverErrors="serverErrors"></item-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="7" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Object2Form from '../../../helpers/Object2Form';
import Utils from '../../../helpers/Utils';
import SaleOrderForm from "./Form.vue";
export default {
    components: {
        'item-form': SaleOrderForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            serverErrors: {},
            form: {
                client: "",
                work: "",


                quotation_id: "",
                discount: "",
                date: "",
                pdf_file: [],
                xml_file: [],
                pdf_url: [],
                xml_url: [],
                products: [
                    // {
                    //     id: "1",
                    //     quantity: "3",
                    //     amount: "4",
                    //     product_name: "test"
                    // }
                ],
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "",
                to: "SaleOrders",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        
        this.index();
        
    },
	methods: {

       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index(){
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.saleOrder.get(this.id)
                .then((resp) => {
                    this.form.client = resp.data.client.name;
                    this.form.work = `${resp.data.work.folio} - ${resp.data.work.name}`;
                    // this.form.quotation_id = resp.data.id;
                    this.form.discount = resp.data.discount;
                    this.form.date = resp.data.date;

                    this.form.products = resp.data.products;

                    this.form.pdf_url = resp.data.pdf_url??"";
                    this.form.xml_url = resp.data.xml_url??"";
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
            // if(this.form.products.length == 0)
            //     return false;
			return this.$refs.form.validate() && this.form.products.length > 0;
            // return true;
		},
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.saleOrder.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'SaleOrders'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));



            data.pdf_file = request.pdf_file;

            if(request.pdf_url == '' && (request.pdf_file instanceof Array))
                data.pdf_file = null;

            if(request.pdf_url != '' && (request.pdf_file instanceof Array))
                delete data.pdf_file;


            data.xml_file = request.xml_file;

            if(request.xml_url == '' && (request.xml_file instanceof Array))
                data.xml_file = null;

            if(request.xml_url != '' && (request.xml_file instanceof Array))
                delete data.xml_file;

            delete data.client;
            delete data.work;

            for (let i = 0; i < data.products.length; i++) {
                delete data.products[i].actions
                delete data.products[i].parameters
                delete data.products[i].name
                
            }


            return Object2Form.objectToFormData(data, "", []);
        }
    },
}
</script>

<style>

</style>